import React from 'react';
import Feature from 'component/Feature';
import './feature.css';

function Features() {
  return (
    <div className="feature-page">
     <Feature />
    </div>
  );
}

export default Features;
